import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { linerNotesEn, linerNotesJa } from '@/mocks/album';
import { useLanguage } from '@/i18n/useLanguage';

// 言語はサイト全体で1つ（Navbar のトグル）。2026-08-15 に統合。

function parseLinerNotes(text: string) {
  const paragraphs = text.split('\n\n').filter(p => p.trim());
  return paragraphs.map((p, i) => {
    if (p.startsWith('---')) return { type: 'divider' as const, content: '', key: i };
    const lines = p.split('\n');
    const isQuote = lines.some(l => l.startsWith('"') || l.startsWith('「') || l.startsWith('“'));
    if (isQuote && lines.length <= 4) {
      return { type: 'quote' as const, content: p, key: i };
    }
    return { type: 'paragraph' as const, content: p, key: i };
  });
}

function renderContent(content: string) {
  return content.split('\n').map((line, idx) => (
    <span key={idx} className="block">
      {line}
    </span>
  ));
}

export default function LinerNotes() {
  const { t } = useTranslation();
  const lang = useLanguage();

  const text = lang === 'en' ? linerNotesEn : linerNotesJa;
  const paragraphs = parseLinerNotes(text);

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-24 pb-20 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <p className="text-xs tracking-[0.3em] text-secondary-500 mb-3">LINER NOTES</p>
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
              Who is the machine?
            </h1>
            <p className="text-sm text-foreground-600">Gen.Y.Sakai</p>
          </div>

          <div className="space-y-8">
            {paragraphs.map((para) => {
              if (para.type === 'divider') {
                return (
                  <div key={para.key} className="flex items-center gap-4 py-2">
                    <div className="flex-1 h-px bg-background-300/40"></div>
                    <div className="w-2 h-2 rounded-full bg-primary-500/50"></div>
                    <div className="flex-1 h-px bg-background-300/40"></div>
                  </div>
                );
              }
              if (para.type === 'quote') {
                return (
                  <blockquote
                    key={para.key}
                    className="pl-5 border-l-2 border-primary-500/40 py-1"
                  >
                    <p className="text-sm md:text-base text-foreground-700 italic leading-relaxed">
                      {renderContent(para.content)}
                    </p>
                  </blockquote>
                );
              }
              return (
                <p
                  key={para.key}
                  className="text-sm md:text-base text-foreground-700 leading-loose whitespace-pre-line"
                >
                  {renderContent(para.content)}
                </p>
              );
            })}
          </div>

          <div className="mt-16 text-center">
            <p className="text-xs text-foreground-500 tracking-wider">
              {t('linerNotes.note')}
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}